// extracted by mini-css-extract-plugin
module.exports = {"content":"DeviationType_content__2C2Y5","submitBtn":"DeviationType_submitBtn__1Tvnj"};